import React, {Component} from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";

class PenyerahanBBNLeasingDetailFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: {},
            dataVariant: [],
            dataWarna: [],
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataVarian();
        await this.fetchDataWarna();
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataVarian = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            this.setState((prevState) => ({
                ...prevState,
                dataVariant: res.data.data.map(item => mapToObjectDDL(item.namaVariant, item.kodeVariant))
            }));
        } catch (error) {
            console.log("error: ", error);
        }
    };

    fetchDataWarna = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA").getAllWarna();
            this.setState((prevState) => ({
                ...prevState,
                dataWarna: res.data.data.map(item => mapToObjectDDL(item.namaWarnaKomersil, item.id))
            }));
        } catch (error) {
            console.log("error: ", error);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <FlexView column>
                            <SimpleInput
                                id="input_text_sales_invoice_number"
                                name="facture"
                                label="No. Faktur Jual"
                                value={this.props.filterData.facture}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <FlexView column vAlignContent="center">
                                <p>Tanggal Faktur Jual:</p>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        date={this.props.filterData.startPeriod}
                                        onChange={(value) =>
                                            this.props.onValueChange("startPeriod", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                    <span className="margin-bottom-20px">To</span>
                                    <SimpleDate
                                        date={this.props.filterData.endPeriod}
                                        onChange={(value) =>
                                            this.props.onValueChange("endPeriod", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleInput
                                id="input_text_book_number"
                                name="bookNumber"
                                label="Nomor Buku"
                                value={this.props.filterData.bookNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_kode_variant"
                                name="kodeVariant"
                                label="Nama Varian"
                                box="multiselect"
                                mandatory
                                options={this.state.dataVariant}
                                value={this.props.filterData.kodeVariant}
                                onChange={(value, {name}) =>
                                    this.props.onValueChange(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_kode_warna"
                                name="kodeWarna"
                                label="Nama Warna"
                                box="multiselect"
                                mandatory
                                options={this.state.dataWarna}
                                value={this.props.filterData.kodeWarna}
                                onChange={(value, {name}) =>
                                    this.props.onValueChange(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_stnk_name"
                                name="stnkName"
                                label="Nama STNK"
                                value={this.props.filterData.stnkName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="buyer"
                                label="Nama Pembeli"
                                value={this.props.filterData.buyer}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="Nomor Rangka"
                                value={this.props.filterData.frameNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="Nomor Mesin"
                                value={this.props.filterData.engineNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_bpkb_number"
                                name="numberBPKB"
                                label="Nomor BPKB"
                                value={this.props.filterData.numberBPKB}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_search_status"
                                box="search"
                                name="pencairan"
                                label="Status Pencairan"
                                isClearable={true}
                                options={[{label: "LUNAS", value: "LUNAS"}, {label: "BELUM LUNAS", value: "BELUM LUNAS"}]}
                                value={this.props.filterData.pencairan}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                        </FlexView>
                        <FlexView hAlignContent="right" style={{gap: "10px"}}>
                            <SimpleButton
                                secondary
                                type="button"
                                text={"Clear"}
                                onClick={this.props.onClearForm}
                            />
                            <SimpleButton
                                type="submit"
                                text={"Terapkan"}
                                onClick={this.props.onSubmit}
                            />
                        </FlexView>

                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default PenyerahanBBNLeasingDetailFilter;
